package com.milta.feature.importjobs.presentation

import com.milta.core.ui.component.ProcessingProgress
import com.milta.core.ui.component.ProcessingStage
import com.milta.feature.importjobs.domain.entity.ImportJob
import com.milta.feature.importjobs.domain.entity.ImportJobStage
import com.milta.feature.importjobs.domain.entity.ImportJobStatus
import kotlin.time.Instant

/** [ImportJob.createdAt] as epoch ms — start of the analysis card's chrono; null if unparseable. */
val ImportJob.startedAtEpochMillis: Long?
    get() = runCatching { Instant.parse(createdAt).toEpochMilliseconds() }.getOrNull()

/**
 * Retour 26/10 — the real progress of a running import, for the analysis card (mobile) and the web
 * drop zone. A Pending job is known as "waiting for the reading" even without a step; a Processing
 * job without [ImportJob.stage] comes from a server that doesn't report progress yet: null, the card
 * then keeps estimating its steps from the chrono.
 */
val ImportJob.realProgress: ProcessingProgress?
    get() {
        val stage = when (stage) {
            ImportJobStage.Reading -> ProcessingStage.Reading
            ImportJobStage.Geocoding -> ProcessingStage.Geocoding
            null -> if (status == ImportJobStatus.PENDING) null else return null
        }
        return ProcessingProgress(
            stage = stage,
            stageStartedAtEpochMillis = stageStartedAtEpochMillis,
            readingDurationSeconds = readingDurationSeconds,
            deliveryCount = deliveryCount,
            geocodedCount = geocodedCount,
            geocodeTotal = geocodeTotal,
        )
    }
